export const companies = [
    "630 Aero Space Lda",
    "AA KİMYA VE DIŞ TİCARET SANAYİ LİMİTED ŞİRKET",
    "AB Skoglunds Mekaniska Verkstad",
    "ACARSAN MAKARNA UN GIDA İNŞAAT SAN VE TİC. A.Ş.",
    "ACHEMETAL TUNGSTEN&MOLYBDENUM CO.,LTD",
    "ADANA TEKNİK SOĞUTMA SANAYİ VE TİCARET LTD. ŞTİ",
    "ADVANTAGE",
    "ADVANTAGE SINTERED METALS,INC.",
    "Aerzener Maschinenfabrik GmbH",
    "A H JABAL GÜMRÜKLEME DENIZCİLİK LOJİSTİK GIDA İTHALAT İHRACAT SANAYI VE DIŞ TİCARET",
    "Aim enterprise group Ltd",
    "AKDEMİR IMPORT & EXPORT TRADING - OSMAN AKDEMİR",
    "ALEKSANDR AMOEV",
    "ALIAUTO S.A.",
    "ALMASA ALDWLYIA FOR IMPORTING PHARMACEUTICAL AND MEDICAL EQUIPMEN",
    "ALPENTECH ELECTROMECHANICAL CONTRACTING LLC",
    "ALTUN GIDA A.Ş",
    "ANITKAYA MAKİNE SANAYİ VE TİCARET LİMİTED ŞİRKETİ",
    "ANTEPSAN",
    "ARES ISI TRANSFER SİSTEMLERİ SANAYİ TİCARET A.Ş.",
    "ARES TRAFO EKIPMANLARI SAN.VE TIC.LTD.STI.",
    "ARROW STAR SHIPPING AND LOGISTICS LLC",
    "ASHLAND SPECIALTIES FRANCE",
    "Asmin Engros AS",
    "Asne ambalaj gıda nakliyat tarım ürünleri inşaat ith.ihr.san.ve tic.ltd.şti",
    "ASSADAKA ALRAQIA CO",
    "A.T.E. Enterprises Private Limited",
    "ATYV DESARROLLOS Y MANUFACTURAS, S.A. DE C.V.",
    "AYD OTOMOTİV ENDÜSTRİ SANAYİ VE TİCARET ANONİM ŞİRKETİ",
    "Baker Hughes EHO Ltd Centrilift Division",
    "BARSAN GLOBAL LOGISTIK GMBH",
    "B&Ç GRİLL EXPRESS",
    "BES YILDIZ SEBZE MEYVE ZIRAI ILACLAR TARIM INSAAT",
    "BIFA BISKUVI VE GIDA SANAYI A.S.",
    "BİFA BİSKÜVİ VE GIDA SANAYİ A.Ş.",
    "BIG Fleisch- und Großhandel GmbH",
    "BLG AutoTerminal Bremerhaven GmbH & Co.",
    "BRÄCKER S.A.S.",
    "Brinkman Tarım Tic. Ltd. Şti.",
    "BRN YATAK BAZA EV TEKS.INS.SAN.TIC.A.S",
    "Brother Group",
    "BÜHNEN GmbH Co. KG",
    "CAGLAYAN SOGUTMA",
    "CANTAŞ GERİ DÖNÜŞÜM SANAYİ DIŞ TİCARET LİMİTED ŞİRKETİ",
    "Capella Depolama Lojistik Dış Tic. A.Ş.",
    "CELIK GRENERGY OTOMOTIVE ELEKTRONIK ENERJI LOJISTIK ITHALAT IHRACAR SANAYI TICARET LIMITED SITKETI",
    "ÇELİK GRENERGY OTO. ELKTR. ENER. LOJ. İTH. İHR. SAN. TİC. LTD. ŞTİ.",
    "CELİLLER LTD. ŞTİ.",
    "Cerabath",
    "CEYTECH MAKİNA SANAYİ VE TİCARET A.Ş.",
    "CHENGXI SHIPYARD CO., LTD",
    "CHINA MAGNETS SOURCE MATERIAL LTD",
    "CNA TASARIM CAM TENTE PERGOLA SİSTEMLERİ İNŞAAT MOB.HURD.İTH İHR SAN VE TİC LTD.ŞTİ",
    "COCA COLA ICECEK A.S.",
    "CONNECT FUTURE LOGISTICS SERVICES LLC",
    "COSTACHEM POLİMER SANAYİ TİCARET A.Ş.",
    "Çukurova Makina İmalat ve Ticaret A.Ş.",
    "DARA INTERNATIONAL",
    "DAYMOON OTOMOTİV YEDEK PARÇA İKLİMLENDİRME İTHALAT İHRACAT TİCARET VE SANAYİ LİMİTED ŞİRKETİ",
    "DEGIRMENCILER Zirai Urun Isleme Paketleme Pazarlam",
    "DONGGUAN HENGYING NONWOVEN TECH CO LTD",
    "DUDAFU HOLDINGS LIMI",
    "DYNAMIC OILS AND FATS FZ-LLC",
    "EKIN GIDA DIS TICARET VE TASIMACILIK LIMITED SIRKETI",
    "EKIN GIDA TARSUS",
    "ELFA SA",
    "ELİTE BOYA VE KİMYEVİ MADDELER DIŞ TİC. A.Ş.",
    "EMRE MAKİNA SANAYİ VE TİCARET A.Ş.",
    "ETIK OUEST",
    "EVERLİGHT EUROPA BV./ROTTERDAM",
    "FAMILITEX TECELAGEM, LDA",
    "FASHION AGENCIES CLUB BV",
    "FAST TURKEY LOJİSTİK VE TURİZM A.Ş.",
    "FEITIAN TECHNOLOGIES CO., LTD.",
    "FINOPIA",
    "Flex2000 - Flexible Products, S.A.",
    "General Fasteners Company",
    "GENERAL MAGNETIC CO.,LTD",
    "GENUINE PARTS COMPANY",
    "G.FIORI INTERNATIONAL SRL",
    "GİFT EXPRESS GIDA TURİZM SANAYİ VE DIŞ TİCARET LİMİTED ŞİRKETİ",
    "Global Concepts Enterprise",
    "GMB INTERNATIONAL SHIPPING",
    "GMM Güven Mühendislik Makina San.Tic.AŞ.",
    "GOLD STAR POWER LIMITED",
    "GOS Otomotiv A.Ş.",
    "HASGÖKÇE UN GIDA SANAYİ VE TİCARET LTD. ŞTİ",
    "HATBORU ROMANIA SA",
    "HATBORU SANAYİ VE TİCARET ANONİM ŞİRKETİ",
    "HAWAR SAEED ISMAEL COMPANY",
    "HEFEI XINHU CANNED MOTOR PUM",
    "HEYCAFÉ CO., LTD.",
    "HTYECH",
    "HÜRSAN PRES",
    "IBTIKAR AL TEKANIA CENETAL TRADING",
    "ICC OILS AND FATS FZE",
    "IMPORTACIONES ALAR S.A. DE C.V.",
    "IMT ENDÜSTRİYEL MAKİNA SAN. VE TİC. LTD. ŞTİ.",
    "İnnosis Makine Tasarım Ar-Ge Sanayi ve Ticaret LTD. ŞTİ.",
    "İNOVATİF ARGE GAZBETON PANEL İNŞAAT İMALAT SANAYİ TİCARET LİMİTED ŞİRKETİ",
    "INOXIM GASTRO HANDEL",
    "INTERPAK AHSAP VE ÜRÜNLERI SANAYI TIC.LTD.STI",
    "ISC INDUSTRIES INC.",
    "ITALISA ( VIETNAM) CO., LTD",
    "ITC Dosing Pumps",
    "JAS Forwarding (Austria) GmbH",
    "JBRIDGE LIMITED",
    "JIANGSU JIACHENG TECHNOLOGY CO.,LTD",
    "JLM GROUP AB",
    "J. STERLING INDUSTRIES LTD",
    "KAMİL ÇELEN",
    "Kapudun Automation Equipment (Guangzhou) CO., ltd",
    "KARAPINAR SUNFLOWER LLC.",
    "KARWANCHI FOR SOFT DRINK & HEALTHY WATER & JUICES & DAIRY AND ENERGY DRINKS. CO. LTD.",
    "KAYA DÖNER-MUSA KAYA",
    "KB MAKİNE İMALAT İTHALAT İHRACAT İNŞAAT SANAYİ VETİCARET LİMİTED ŞİRKET",
    "Kemena GmbH",
    "KIRMIZIDAM GIDA ORGANİK TARIM VE TURİZM TİCARET LTD.ŞTİ",
    "Koseler-Sarikaya Paketleme Tarim Urunleri Otomotiv",
    "LAUBE TECHNOLOGY",
    "LEON IMPORT",
    "LİMAK ÇİMENTO",
    "LIVENZA GRANITO LLP",
    "MAC 3 SAS",
    "MARIN G. & C. SRL",
    "MASTERPORT GÜMRÜKLEME VE DIŞ TİCARET LİMİTED ŞİRKETİ",
    "MBFLEX KİMYA İTH.İHR.SAN. VE TİC.LTD.ŞTİ.",
    "MEDI TRADING FZE",
    "MEHMET ÖZEN MAK. SAN. VE TEİC. A.Ş.",
    "Me-ka Endüstriyel Tasarım Kalıp Medikal Plastik İmalat San. ve Tic. Ltd. Şti.",
    "Menas-Mersin Zirai Urunler Isleme Ihracat Sanayi",
    "MENAS TÖMÜK",
    "MERSİN COCA COLA ICECEK A.S.",
    "Mersin Uluslararası Liman İşletmeciliği A.Ş.",
    "MEYSAŞ PAK.FAB.",
    "MHE GROUP INDONESIA",
    "MICRONS INDIA",
    "Micro Precision",
    "Midwest Safety Products Inc.",
    "Millennium Logistics (Shenzhen) Ltd Shanghai Branch",
    "MİSEM KİMYA SAN. VE TİC. LTD. ŞTİ",
    "MSACMACI DIS TICARET LIMITED SIRKETI",
    "M SAÇMACI DIŞ TİCARET LİMİTED ŞTİ.",
    "MST SATIS PAZ.VE YATIRIM A.S.",
    "Muka Metal Tic ve San A.Ş.",
    "MUNDIFIOS S.A.",
    "NINGBO ICEBERG ELECTRONIC APPLIANCE CO.,LTD",
    "NISSHA EIMO TECHNOLOGIES",
    "Nissha Eimo Technologies C",
    "NNOSİS MAKİNE TASARIM ARGE SAN. ve TİC. LTD.ŞTİ.",
    "NORDEX ENERGY GMBH NORDEX ENERGY GMBH",
    "NORDEX ENERGY SE & CO. KG-CWH C/O SPED. HOMTRANS SERVİCE GMBH",
    "Nordic Water Products AB",
    "NORMANDISE LOGISTIQUE",
    "NOXAE EQUIPAMENTOS EM AÇO INOX AUTOMAÇÃO E",
    "N.U.R. GENERATION SDN BHD",
    "Omnia Della Toffola S.p.A.",
    "Oskar Rüegg Bulgaria EOOD.",
    "PERSEUS OCEAN AGENCY TURKEY",
    "PHILI-ORIENT LOGISTICS (M) SDN BHD (462696-V)",
    "Plastic Omnium Lighting",
    "PORT ROYAL ENERJİ REKLAM SAN VE TİC LTD ŞTİ",
    "PT. KERRY INGREDIENTS INDONESIA",
    "PT. PERMATA HIJAU PALM OLEO",
    "QINGDAO D&E INTERNATIONAL TRADE CO., LTD",
    "QINGDAO RIWELL ADVANCED MATERIALS CO., LTD",
    "RACHE PROCESS EQUIPMENT LLP",
    "Ram Dış Ticaret A.Ş.",
    "RAWAT AL ALAM",
    "RİMAŞ DERİ",
    "ROMA INDUSTRY METAL SANAYI VE TICARET LIMITED SIRKETI",
    "SAFRAN LANDING SYSTEMS",
    "ŞAHİN BALANS SANAYİ TURİZM VE PETROL ÜRÜNLERİ TİCARET LİMİTED ŞİRKETİ",
    "ŞERİFOĞLU B.V",
    "SERTEL VIDA METAL A.S.",
    "SET DENT",
    "SHANDONG HETIAN POWER TECHNOLOGY CO., LTD",
    "SHAREKAT GRAND PLAST COMPANY FOR MANUFACTURE AND TRADE OF PLASTIC",
    "SHENZHEN AKUSENSE TECHNOLOGY CO., LTD",
    "S.S.P. OTOMOTİV SAN. VE DIŞ TİCARET A.Ş.",
    "Stryker Medical",
    "SUDAIS WAIS LTD KANDAHAR",
    "SULZER ITALY S.R.L.",
    "TAIWAN RIKEN INDUSTRIAL CO., LTD.",
    "TAMCOLD ENDUSTRIYEL SOĞUTMA LTD.ŞTİ.",
    "TARGA MOTORS LTD",
    "TECHNIPLAS MAKING TGE CONNECTED WORLD",
    "TECHNIPLAS US LLC",
    "TEKSAN JENERATOR ELEKTRIK SAN. VE TIC. A.S.",
    "TES s.r.l. Unipersonale",
    "THEMOR COMPANY FOR NUTRİTİON AND CATERİNG",
    "THYSSENKRUPP STEEL EUROPE AG",
    "TO ORDER OF GREEN SQUARE ELECT.DEVICES TR.",
    "TOROS PISTON OTOMOTIV YEDEK PARCA IMALAT SAN. VE TIC. LTD.STI.",
    "TO THE ORDER OF QNB BANK A.S.",
    "TOURISTIC AVIATION SERVICES LIMITED",
    "TRANSPORTES EL MOSCA (HERCAS)",
    "TUĞRA GLOBAL METAL SAN.VE TİC.LTD.ŞTİ.",
    "TURISTIK HAVA TAŞ AŞ",
    "Turistik Hava Taşımacılık A.Ş.",
    "Turk Hava Yollari Teknik A.S",
    "ÜNAL BİLİR",
    "UNICOM TECH ELECTRIC LIMITED",
    "UNIQUE ENERGOS PVT. LTD",
    "Universal Electro Engineering",
    "VARLIK MAKİNA",
    "VAYA GIDA SANAYI VE TICARET A.S.",
    "VAYA IMPEX UK LTD",
    "Vellteks Kumaş Tekstil Sanayi ve Ticaret A.Ş.",
    "VERTESKER-Gepker Kft. HU-2800",
    "VOLTAMP POWER SAOC",
    "WALVOIL FLUID POWER (INDIA) PVT. LTD.",
    "WANSHIDA COFFEE MACHINE (HANGZHOU) CO., LTD",
    "WENZHOU COC AUTO PARTS CO.,LTD",
    "WIMAS",
    "WINWIN LINES LIMITED",
    "Wipro Enterprises (P) Limited",
    "WORLDPAC, INC.",
    "XİAMEN R&T PLUMBİNG TECHNOLOGY CO. LTD.",
    "XIAMEN YANGCHENG IMPORT & EXPORT",
    "XUZHOU PRESS TECHNOLOGY MACHINERY CO.,LTD",
    "YÖRESEL TÜKETİM MALLARI GIDA SAN.TİC.LTD.ŞTİ",
    "YÜKLEYİCİ SEMT TARIM URUN.ITH.IHR.TASIMACILIK INSAAT.IMALAT",
    "YUYAO KEBANG NEW MATERIAL TECHNOLOGY CO., LTD",
    "Zancaner S.r.l",
    "ZEB FOOD GIDA SANAYİ VE TİCARET LİMİTED ŞİRKETİ",
    "ZHEJIANG DATIAN MACHINE CO.,LTD",
    "Zhejiang Linkcool Technology Co.,Ltd",
    "ZHONGSHAN MEITU PLASTIC IND.CO.,LTD"
];
